import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Rupee from 'views/Rupee';
import {
  Row,
  Columns,
} from 'views/Grid';
import ConvenienceFeesAccordion from '../convenience-fee/ConvenienceFeesAccordion';
import { getFullName } from 'config/utils';

const ProductsMerchantHeader = ({
  preview,
  sellerAvatar,
  seller,
  title,
  totalAmountFormatted,
  showDeferred,
  showConvenienceFee,
  finalizePurchase: {
    selectedPaymentMode,
  },
}) => (
  <div className={classNames('payments-header is--product-payment', preview ? 'has--preview' : null, sellerAvatar ? 'has--avatar' : null)}
    style={preview && showDeferred ? {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${preview})`,
    } : null}>
    {
      sellerAvatar ? (
        <div className="payments-header--avatar-container sticky">
          <img
            className="payments-header--avatar"
            height={60} width={60}
            src={showDeferred ? sellerAvatar : null}
            />
        </div>
      ) : null
    }

    <div className="offer--merchant">
      <Row>
        <Columns className="small-12 center">
          {getFullName(seller)}
        </Columns>
      </Row>
    </div>

    <div className="offer--specs">
      <div
        className="soft--sides"
        style={{ wordWrap: 'break-word', lineHeight: '1.2' }}>
        {title}
      </div>
    </div>
    { showConvenienceFee && selectedPaymentMode ?
      <div className="background-white soft--sides soft--top text-black">
        <div className="text-medium">
          <span>Amount</span>
          <span className="right"><Rupee value={totalAmountFormatted} /></span>
          <ConvenienceFeesAccordion />
        </div>
      </div> :
      null
    }
  </div>
);

const mapStateToProps = ({
  settings: {
    showConvenienceFee,
    isRetrying,
  },
  finalizePurchase,
  retry,
}) => {
  if (isRetrying) {
    return {
      showConvenienceFee,
      finalizePurchase: retry.finalizePurchase,
    };
  }
  return {
    showConvenienceFee,
    finalizePurchase,
  };
};

export default connect(mapStateToProps)(ProductsMerchantHeader);



// WEBPACK FOOTER //
// ./src/payments/views/products/ProductsMerchantHeader.js